import { css, cx } from "@emotion/css"

const styles = {
  card: css`
    padding: var(--spacing-xl, 24px);
    border-radius: 4px;
    background-color: var(--white);
    color: var(--black);
    display: flex;
    flex-direction: column;
    width: 100%;
  `,
  title: css`
    font-weight: bold;
    font-size: 0.875rem;
    line-height: 1rem;
    color: inherit;
  `,
}

type CardProps = {
  children: React.ReactNode
  className?: string
}

export function Card(props: CardProps) {
  const { children, className } = props
  return <div className={cx(styles.card, className)}>{children}</div>
}

type CardTitleProps = {
  children: React.ReactNode
  className?: string
}

export function CardTitle(props: CardTitleProps) {
  const { children, className } = props
  return <div className={cx(styles.title, className)}>{children}</div>
}
